import type { EditorialResource } from "@/components/resources/ResourceEditorialPrimitives";

export const LLANTAS_CAVAZOS_CASE_STUDY: EditorialResource = {
  id: "llantas-cavazos-case-study",
  slug: "llantas-cavazos-migration-case-study",
  slug_es: "caso-llantas-cavazos-migracion",
  title_en: "Llantas Cavazos: Migrating 8,000+ Tire SKUs to Shopify Without Disrupting the Business",
  title_es: "Cómo Llantas Cavazos migró más de 8,000 SKUs a Shopify sin frenar la operación",
  excerpt_en:
    "How an established Monterrey tire retailer migrated more than 8,000 SKUs to Shopify, added tire-size search and inventory synchronization, and retained more than 90% of organic traffic during the first week.",
  excerpt_es:
    "Cómo una llantera establecida de Monterrey migró más de 8,000 SKUs a Shopify, añadió búsqueda por medida y sincronización de inventario, y conservó más del 90% del tráfico orgánico durante la primera semana.",
  tags_en: ["Shopify Migration", "Case Study", "Complex Catalogs", "Automotive Ecommerce", "Technical SEO"],
  tags_es: ["Migración Shopify", "Caso de estudio", "Catálogos complejos", "Ecommerce automotriz", "SEO técnico"],
  cover_image_url: null,
  cover_image_url_es: null,
  reading_minutes: 17,
  updated_at: "2026-07-30T14:53:00.000Z",
  reviewed_at: "2026-07-30T14:53:00.000Z",
  cluster: "migration",
  content_type: "case_note",
};

export const FASHIONABLE_CANES_CASE_STUDY: EditorialResource = {
  id: "fashionable-canes-seo-case-study",
  slug: "fashionable-canes-seo-case-study",
  slug_es: "caso-fashionable-canes-seo",
  title_en: "Fashionable Canes: 15,000+ SKUs, Shopify Theme Migration and SEO Recovery",
  title_es: "Fashionable Canes: 15.000+ SKUs, migración de theme Shopify y recuperación SEO",
  excerpt_en: "How a 15,000+ SKU Shopify retailer recovered rankings within 60 days and recorded +180% organic traffic, a 350% ROI lift, and #1 category SERPs after theme and technical SEO work.",
  excerpt_es: "Cómo un retailer Shopify de 15.000+ SKUs recuperó rankings en 60 días y registró +180% de tráfico orgánico, +350% de ROI y posiciones #1 tras la migración y recuperación SEO.",
  tags_en: ["Shopify SEO", "Case Study", "Theme Migration", "Large Catalogs", "Technical SEO"],
  tags_es: ["SEO Shopify", "Caso de estudio", "Migración de theme", "Catálogos grandes", "SEO técnico"],
  cover_image_url: null,
  cover_image_url_es: null,
  reading_minutes: 11,
  updated_at: "2026-08-20T14:30:00.000Z",
  reviewed_at: "2026-08-20T14:30:00.000Z",
  cluster: "technical-seo",
  content_type: "case_note",
};

export const PETWELL_CASE_STUDY: EditorialResource = {
  id: "petwell-magento-migration-case-study",
  slug: "petwell-magento-migration-case-study",
  slug_es: "caso-petwell-migracion-magento",
  title_en: "Petwell: Migrating 10,000+ SKUs from Magento to Shopify Plus in 8 Weeks",
  title_es: "Petwell: migración de 10.000+ SKUs de Magento a Shopify Plus en 8 semanas",
  excerpt_en: "How Petwell moved 10,000+ SKUs from Magento to Shopify Plus in eight weeks with zero downtime, historical data continuity, taxonomy work, and redirect mapping.",
  excerpt_es: "Cómo Petwell migró 10.000+ SKUs de Magento a Shopify Plus en ocho semanas con cero downtime, histórico, taxonomía y mapeo de redirecciones.",
  tags_en: ["Shopify Plus", "Magento Migration", "Case Study", "Complex Catalogs", "SEO Migration"],
  tags_es: ["Shopify Plus", "Migración Magento", "Caso de estudio", "Catálogos complejos", "Migración SEO"],
  cover_image_url: null,
  cover_image_url_es: null,
  reading_minutes: 10,
  updated_at: "2026-08-20T14:30:00.000Z",
  reviewed_at: "2026-08-20T14:30:00.000Z",
  cluster: "migration",
  content_type: "case_note",
};

export const SELF_CARE_CASE_STUDY: EditorialResource = {
  id: "self-care-shopify-growth-case-study",
  slug: "self-care-is-for-everyone-growth-case-study",
  slug_es: "caso-self-care-is-for-everyone-crecimiento",
  title_en: "Self-Care Is For Everyone: A Custom Shopify Store Built for Brand Growth",
  title_es: "Self-Care Is For Everyone: una tienda Shopify custom construida para crecer",
  excerpt_en: "How a custom Shopify rebuild supported high-visibility launches while the project recorded +42% collaboration-launch CVR and a 46% reduction in mobile LCP.",
  excerpt_es: "Cómo un rebuild Shopify custom soportó lanzamientos de alta visibilidad mientras el proyecto registró +42% de CVR y una reducción del 46% en LCP móvil.",
  tags_en: ["Shopify Growth", "Case Study", "Custom Theme", "Conversion", "Performance"],
  tags_es: ["Crecimiento Shopify", "Caso de estudio", "Theme custom", "Conversión", "Performance"],
  cover_image_url: null,
  cover_image_url_es: null,
  reading_minutes: 10,
  updated_at: "2026-08-20T14:30:00.000Z",
  reviewed_at: "2026-08-20T14:30:00.000Z",
  cluster: "conversion",
  content_type: "case_note",
};

export const MP_HEALTH_CASE_STUDY: EditorialResource = {
  id: "mp-health-shopify-systems-case-study",
  slug: "mp-health-squarespace-migration-case-study",
  slug_es: "caso-mp-health-migracion-squarespace",
  title_en: "MP Health: Squarespace to Shopify with a Custom Medical Inventory System",
  title_es: "MP Health: de Squarespace a Shopify con un sistema custom de inventario médico",
  excerpt_en: "How MP Health moved to Shopify in 4–6 weeks with component-level IV inventory logic, Shopify POS, local SEO, and mobile UX improvements.",
  excerpt_es: "Cómo MP Health migró a Shopify en 4–6 semanas con inventario por componentes para IV, Shopify POS, SEO local y mejoras de UX móvil.",
  tags_en: ["Shopify Development", "Case Study", "Custom Inventory", "Shopify POS", "Squarespace Migration"],
  tags_es: ["Desarrollo Shopify", "Caso de estudio", "Inventario custom", "Shopify POS", "Migración Squarespace"],
  cover_image_url: null,
  cover_image_url_es: null,
  reading_minutes: 10,
  updated_at: "2026-08-20T14:30:00.000Z",
  reviewed_at: "2026-08-20T14:30:00.000Z",
  cluster: "development",
  content_type: "case_note",
};

export const FASHIONABLE_INC_CASE_STUDY: EditorialResource = {
  id: "fashionable-inc-shopify-plus-partnership-case-study",
  slug: "fashionable-inc-partnership-case-study",
  slug_es: "caso-fashionable-inc-colaboracion",
  title_en: "Fashionable INC: A 6+ Year Shopify Plus Partnership Across Three Stores",
  title_es: "Fashionable INC: más de 6 años de partnership Shopify Plus en tres tiendas",
  excerpt_en: "How a six-year technical relationship supports three Shopify Plus stores across theme migrations, SEO, custom development, and performance without conflating portfolio support with merchant revenue attribution.",
  excerpt_es: "Cómo una relación técnica de más de seis años soporta tres tiendas Shopify Plus con migraciones, SEO, custom development y performance sin atribuir a la agencia el revenue del merchant.",
  tags_en: ["Shopify Plus", "Case Study", "Multi-store", "Technical Partnership", "Ecommerce Operations"],
  tags_es: ["Shopify Plus", "Caso de estudio", "Multi-store", "Partnership técnico", "Operaciones ecommerce"],
  cover_image_url: null,
  cover_image_url_es: null,
  reading_minutes: 10,
  updated_at: "2026-08-20T14:30:00.000Z",
  reviewed_at: "2026-08-20T14:30:00.000Z",
  cluster: "general",
  content_type: "case_note",
};

export const SHOPIFY_PLUS_PRICING_RESOURCE: EditorialResource = {
  id: "shopify-plus-pricing-2026",
  slug: "shopify-plus-pricing",
  slug_es: "precios-shopify-plus",
  title_en: "Shopify Plus Pricing in 2026: Platform Fees, Real Cost and TCO",
  title_es: "Precio de Shopify Plus en 2026: tarifa, costos reales y TCO",
  excerpt_en: "A current breakdown of Shopify Plus subscription pricing, payment and expansion-store costs, implementation expenses, and a practical total-cost-of-ownership model.",
  excerpt_es: "Desglose vigente de la suscripción Shopify Plus, costos de pagos y expansion stores, implementación y un modelo práctico de costo total de propiedad.",
  tags_en: ["Shopify Plus", "Pricing", "TCO", "Enterprise Ecommerce", "Decision Guide"],
  tags_es: ["Shopify Plus", "Precios", "TCO", "Ecommerce enterprise", "Guía de decisión"],
  cover_image_url: null,
  cover_image_url_es: null,
  reading_minutes: 12,
  updated_at: "2026-08-24T18:45:00.000Z",
  reviewed_at: "2026-08-24T18:45:00.000Z",
  cluster: "general",
  content_type: "buyer_intent",
};

export const SHOPIFY_B2B_RESOURCE: EditorialResource = {
  id: "shopify-b2b-2026",
  slug: "shopify-b2b",
  slug_es: "shopify-b2b",
  title_en: "Shopify B2B in 2026: What Every Plan Gets and What Still Requires Plus",
  title_es: "Shopify B2B en 2026: qué incluye cada plan y qué sigue requiriendo Plus",
  excerpt_en: "A current guide to Shopify B2B after the April 2026 plan change, including the three-catalog non-Plus limit, Plus-only capabilities, B2B + DTC architecture and systems ownership.",
  excerpt_es: "Guía vigente de Shopify B2B tras el cambio de abril de 2026: límite de tres catálogos sin Plus, capacidades exclusivas, arquitectura B2B + DTC y ownership de sistemas.",
  tags_en: ["Shopify B2B", "Shopify Plus", "Wholesale", "Architecture", "ERP Integration"],
  tags_es: ["Shopify B2B", "Shopify Plus", "Wholesale", "Arquitectura", "Integración ERP"],
  cover_image_url: null,
  cover_image_url_es: null,
  reading_minutes: 14,
  updated_at: "2026-08-24T18:45:00.000Z",
  reviewed_at: "2026-08-24T18:45:00.000Z",
  cluster: "development",
  content_type: "pillar",
};

const STATIC_RESOURCES: EditorialResource[] = [
  SHOPIFY_PLUS_PRICING_RESOURCE,
  SHOPIFY_B2B_RESOURCE,
  FASHIONABLE_CANES_CASE_STUDY,
  PETWELL_CASE_STUDY,
  SELF_CARE_CASE_STUDY,
  MP_HEALTH_CASE_STUDY,
  FASHIONABLE_INC_CASE_STUDY,
  LLANTAS_CAVAZOS_CASE_STUDY,
];

export function withStaticResources(resources: EditorialResource[]) {
  const staticSlugs = new Set(STATIC_RESOURCES.flatMap((resource) => [resource.slug, resource.slug_es].filter(Boolean)));
  const withoutDuplicates = resources.filter(
    (resource) => !staticSlugs.has(resource.slug) && !staticSlugs.has(resource.slug_es ?? ""),
  );
  return [...withoutDuplicates, ...STATIC_RESOURCES];
}
